var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { Input, Select, Option, Typography } from "@mui/joy";
export default function Placeholder(_a) {
    var _b, _c;
    var widget = _a.widget;
    return (_jsx("div", __assign({ className: "w-full h-full mt-2 overflow-scroll" }, { children: _jsx(Typography, __assign({ level: (_b = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _b === void 0 ? void 0 : _b.elementType }, { children: (_c = widget.payload) === null || _c === void 0 ? void 0 : _c.property })) })));
}
function WidgetSettings(_a) {
    var _b, _c;
    var widget = _a.widget, onChange = _a.onChange;
    var contentTypes = {
        h1: "Header 1",
        h2: "Header 2",
        h3: "Header3",
        h4: "Header 4",
        "title-lg": "Titre Large",
        "title-md": "Titre Moyen",
        "title-sm": "Titre Petit",
        "body-lg": "Contenu Large",
        "body-md": "Contenu Moyen",
        "body-sm": "Contenu Petit",
    };
    return (_jsxs("div", { children: [_jsx("label", __assign({ htmlFor: "content-type-button", id: "content-type-label" }, { children: "Type de contenu" })), _jsx(Select, __assign({ slotProps: {
                    button: {
                        id: "content-type-button",
                        "aria-labelledby": "content-type-label content-type-button",
                    },
                }, startDecorator: _jsx("span", __assign({ className: "px-2 rounded-md bg-slate-200" }, { children: ((_b = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _b === void 0 ? void 0 : _b.elementType) || "" })), value: ((_c = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _c === void 0 ? void 0 : _c.elementType) || "", onChange: function (event, v) {
                    onChange && onChange(widget, __assign(__assign({}, widget.payload), { elementType: v }));
                } }, { children: Object.keys(contentTypes).map(function (k) { return (_jsx(Option, __assign({ value: k }, { children: _jsx(Typography, __assign({ level: k }, { children: contentTypes[k] })) }), k)); }) })), _jsx("label", __assign({ htmlFor: "content-value", id: "content-value-label" }, { children: "Contenu" })), _jsx(Input, { slotProps: {
                    input: {
                        id: "content-value",
                        "aria-labelledby": "content-value content-value-label",
                    },
                }, value: (widget === null || widget === void 0 ? void 0 : widget.payload.property) || "", onChange: function (event) {
                    var value = event.target.value;
                    onChange && onChange(widget, __assign(__assign({}, widget.payload), { property: value }));
                } })] }));
}
widgetsDictionary.register("widget/test", {
    name: "Widget d'exemple",
    display: Placeholder,
    settings: WidgetSettings,
});
